export default function routeForEndpoint(endpoint: string): string {
  const tokens = endpoint.substring(1).split('/'); // drop the leading slash
  const routeTokens = tokens.map((token) => {
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string' is not assignable to par... Remove this comment to see the full error message
    if (!isNaN(token)) {
      return '{id}';
    }
    if (token.includes('-')) {
      return '{uuid}';
    }
    return token;
  });
  return routeTokens.join('/');
}
